import "./edit/sale-edit.module";
import "../shared/published-icons-list/published-icons-list.component";
import "../shared/translations/translations-text-area.component";
import { AbsenteeBidsService } from "./absenteeBids.service";

angular
    .module("thor.sales", [
        "thor.sale-edit",
        "thor.shared.published-icons-list.component",
        "thor.shared.translations.translations-text-area.component"
    ])
    .service("absenteeBidsService", AbsenteeBidsService);
